import { create } from "zustand";
import { Appointment } from "../../features/appointments/types/Appointment";

interface ConsultsState {
    specialistConsultsLeft: number | null;
    nutritionistConsultsLeft: number | null;
    specialistFutureConsults: Appointment[] | null;
    nutritionistFutureConsults: Appointment[] | null;
    mostRecentFutureAppointment: Appointment | null;
    allAppointments: Appointment[] | null;
    allFutureAppointments: Appointment[] | null;
    allPastAppointments: Appointment[] | null;
}

interface ConsultsStore {
    consultsData: ConsultsState;
    updateConsultsData: (updates: Partial<ConsultsState>) => void;
    clearConsultsData: () => void;
}

// Load consultsData from localStorage
const loadConsultsData = (): ConsultsState => {
    const storedData = localStorage.getItem("consultsData");
    return storedData ? JSON.parse(storedData) : {
        specialistConsultsLeft: null,
        nutritionistConsultsLeft: null,
        specialistFutureConsults: null,
        nutritionistFutureConsults: null,
        mostRecentFutureAppointment: null,
        allAppointments: null,
        allFutureAppointments: null,
        allPastAppointments: null,
    };
};

export const useConsultsStore = create<ConsultsStore>((set) => ({
    consultsData: loadConsultsData(),

    updateConsultsData: (updates) => {
        set((state) => {
            const updatedData = { ...state.consultsData, ...updates };
            localStorage.setItem("consultsData", JSON.stringify(updatedData)); // Save as one object
            return { consultsData: updatedData };
        });
    },

    clearConsultsData: () => {
        set({
            consultsData: {
                specialistConsultsLeft: null,
                nutritionistConsultsLeft: null,
                specialistFutureConsults: null,
                nutritionistFutureConsults: null,
                mostRecentFutureAppointment: null,
                allAppointments: null,
                allFutureAppointments: null,
                allPastAppointments: null,
            },
        });
        localStorage.removeItem("consultsData"); // Remove entire object
    },
}));